import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M7.04999 9.67302C6.86252 9.86055 6.7572 10.1149 6.7572 10.38C6.7572 10.6452 6.86252 10.8995 7.04999 11.087L11.293 15.33C11.4805 15.5175 11.7348 15.6228 12 15.6228C12.2652 15.6228 12.5195 15.5175 12.707 15.33L16.95 11.087C17.0428 10.9941 17.1165 10.8838 17.1667 10.7625C17.2169 10.6411 17.2427 10.511 17.2427 10.3797C17.2426 10.2483 17.2167 10.1183 17.1664 9.99694C17.1161 9.8756 17.0424 9.76537 16.9495 9.67252C16.8566 9.57968 16.7463 9.50604 16.6249 9.45582C16.5036 9.4056 16.3735 9.37978 16.2421 9.37982C16.1108 9.37987 15.9807 9.40579 15.8594 9.45609C15.7381 9.5064 15.6278 9.58011 15.535 9.67302L12 13.208L8.46399 9.67302C8.27646 9.48555 8.02215 9.38024 7.75699 9.38024C7.49182 9.38024 7.23752 9.48555 7.04999 9.67302Z"
    fillRule="evenodd"
  />,
  'CornerDown',
)
